import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Grid,
  Typography,
} from '@material-ui/core';

import useStyles from './styles';

function Header({
  className,
  cleanFilters,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.rootHeader, className)}
      container
      justifyContent="space-between"
      spacing={3}
      alignItems="center"
      {...rest}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant="h3"
            color="textPrimary"
          >
            Reportes
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  cleanFilters: PropTypes.func,
};

Header.defaultProps = {
  className: null,
  cleanFilters: null,
};

export default Header;
